import React from 'react';
import classNames from 'classnames';
import {
  SelectableProps,
  SelectableTypes,
  SelectableColors
} from 'interfaces/selectable/selectable';

import styles from './selectableStyles.scss';

export interface IProps extends SelectableProps {
  color?: SelectableColors;
  disabled?: boolean;
  isDarkTheme?: boolean;
  joyrideTarget?: string;
}

const Selectable: React.FunctionComponent<IProps & React.InputHTMLAttributes<HTMLInputElement>> = ({
  id,
  selectableType = SelectableTypes.CHECKBOX,
  analyticsTag,
  children,
  disabled = false,
  color = 'default',
  joyrideTarget = '',
  isDarkTheme,
  ...props
}): React.ReactElement => (
  <div className={styles.container} data-joyride-target={joyrideTarget}>
    <input id={id} type={selectableType} data-heap={analyticsTag} disabled={disabled} {...props} />
    <label
      data-testid="label"
      htmlFor={id}
      className={classNames({
        [styles.disabled]: disabled,
        [styles[color]]: color,
        [styles[`${color}-darkTheme`]]: isDarkTheme
      })}
    >
      {children}
    </label>
  </div>
);

export default Selectable;
